export default "__VITE_PUBLIC_ASSET__cbab31f5__"